import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { B130ReportAPI } from "components/Apis/Pulse";
import { PulseScraperAPI } from "components/Apis/Pulse";

export const getB130Entries = createAsyncThunk(
    'pulse/B130Report/getB130Entries',
    async (filters = {}, { rejectWithValue }) => {
        try {
            const response = await B130ReportAPI.getEntries(filters);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const getKPITeams = createAsyncThunk(
    'pulse/B130Report/getKPITeams',
    async (filters = {}, { rejectWithValue }) => {
        try {
            const response = await B130ReportAPI.getKPITeams(filters);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const getReport = createAsyncThunk(
    'pulse/B130Report/getReport',
    async ({ year, week }, { rejectWithValue }) => {
        try {
            const response = await PulseScraperAPI.getReport(year, week);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const getPulseMVPS = createAsyncThunk(
    'pulse/B130Report/getPulseMVPS',
    async (filters = {}, { rejectWithValue }) => {
        try {
            const response = await B130ReportAPI.getPulseMVPs(filters);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const getTopCustomers = createAsyncThunk(
    'pulse/B130Report/getTopCustomers',
    async ({ year, week }, { rejectWithValue }) => {
        try {
            const response = await PulseScraperAPI.getTopCustomers(year, week);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

const B130ReportSlice = createSlice({
    name: 'pulse/B130Report',
    initialState: {
        entries: [],
        kpiTeams: [],
        pulseMVPS: [],
        topCustomers: {
            loading: false,
            error: null,
            data: [],
        },
        report: null,
        loading: false,
        error: null,
        filters: {},
    },
    reducers: {
        setFilters: (state, action) => {
            state.filters = { ...state.filters, ...action.payload };
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getB130Entries.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getB130Entries.fulfilled, (state, action) => {
                state.loading = false;
                state.entries = action.payload;
            })
            .addCase(getB130Entries.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
        builder
            .addCase(getReport.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getReport.fulfilled, (state, action) => {
                state.loading = false;
                state.report = action.payload;
            })
            .addCase(getReport.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
        builder
            .addCase(getKPITeams.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getKPITeams.fulfilled, (state, action) => {
                state.loading = false;
                state.kpiTeams = action.payload; // Assuming you want to store KPI teams
            })
            .addCase(getKPITeams.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload; // Store error message
            });
        builder
            .addCase(getPulseMVPS.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getPulseMVPS.fulfilled, (state, action) => {
                state.loading = false;
                state.pulseMVPS = action.payload; // Assuming you want to store pulse MVPs
            })
            .addCase(getPulseMVPS.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload; // Store error message
            });
        builder
            .addCase(getTopCustomers.pending, (state) => {
                state.topCustomers.loading = true;
                state.topCustomers.error = null;
            })
            .addCase(getTopCustomers.fulfilled, (state, action) => {
                state.topCustomers.loading = false;
                state.topCustomers.data = action.payload; // Assuming you want to store top customers
            })
            .addCase(getTopCustomers.rejected, (state, action) => {
                state.topCustomers.loading = false;
                state.topCustomers.error = action.payload; // Store error message
            });
    },
});

export const { setFilters } = B130ReportSlice.actions;
export default B130ReportSlice.reducer;